var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmail = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 1.25C14 0.5625 13.37 0 12.6 0H1.4C0.63 0 0 0.5625 0 1.25V8.75C0 9.4375 0.63 10 1.4 10H12.6C13.37 10 14 9.4375 14 8.75V1.25ZM12.6 1.25L7 4.375L1.4 1.25H12.6ZM12.6 8.75H1.4V2.5L7 5.625L12.6 2.5V8.75Z",
    fill: "#F26722"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/email.71ba58b30682db80a49e58763efdb257.svg";